import styled from "@emotion/styled";
import { GridListItem } from "react-aria-components";

export const StyledGridListItem = styled(GridListItem)`
  display: flex;
  max-width: 784px;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding: ${({ theme }) => theme.spacing["4"]} ${({ theme }) => theme.spacing["4"]};
  min-height: 60px;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.default};

  outline: none;

  ${({ onAction, theme }) =>
    !!onAction &&
    `
    user-select: none;
    cursor: pointer;

    &[data-focused] {
      background-color: ${theme.colors.background.list.hover};
    }

    &[data-selected] {
      background-color: ${theme.colors.background.list.selected};
    }

    &:hover:not([data-disabled]) {
      background-color: ${theme.colors.background.list.hover};
    }
  `}

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  justify-content: center;
`;

export const StyledLeftAddon = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledRightAddon = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
`;
